import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Form,
  Select,
  Input,
  Radio,
  Typography,
  Space,
  Table,
  notification,
  Modal,
} from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import jsonSpanish from '../../../lang/es/capituloIII.json';
import jsonEnglish from '../../../lang/en/chapterIII.json';

import { get, patch } from '../../../api/modules/answers';

import LoadingModal from '../../../components/LoadingModal';

import INTERNAL_LINKS from '../../../enum/InternalLinks';
import FORM_MESSAGES from '../../../enum/FormMessages';

const { Title } = Typography;
const { confirm } = Modal;

const PollChapterIII = ({ history, match }) => {
  const [form] = Form.useForm();
  const [lang] = useState(match.params.lang);
  const [fileLang, setFileLang] = useState(jsonEnglish);
  const [loading, setLoading] = useState(false);
  const [q11_11, setQ11_11Other] = useState(false);
  const Q12AnswersOptions = {
    en: ["Very low", "Low", "Medium", "High", "Very high", "Not apply"],
    es: ["Muy baja", "Baja", "Media", "Alta", "Muy alta", "No Aplica"]
  };
  const [q10BRequired, setQ10BRequired] = useState(true);
  const [q10CRequired, setQ10CRequired] = useState(true);
  const [q10DRequired, setQ10DRequired] = useState(true);
  const [q11Required, setQ11Required] = useState(true);
  const [statusForm, setStatusForm] = useState(0);
  const [requiredItems, setRequiredItems] = useState(false);
  const [answer, setAnswer] = useState({});
  
  useEffect(() => {
    getAnswer();
    if (lang === 'en') {
      setFileLang(jsonEnglish);
    } else if (lang === 'es') {
      setFileLang(jsonSpanish);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAnswer = async () => {
    let response = await get(match.params.id);
    setAnswer(response.data);
    form.setFieldsValue(response.data);
    validQ10a();
    validQ10b();
    validQ10c();
    validQ10d();
    validQ11();
    handleQ11_11(response.data.q11_11, 11);
  };

  const handleQ11_11 = (value, text) => {
    value = parseInt(value);
    text = parseInt(text);

    if (text === 11 && !isNaN(value)) {
      setQ11_11Other(true);
    }
  };
  
  const save = async (data) => {
    setLoading(true);
    try {
      data["status_iii"] = statusForm;
      await patch(match.params.id, data);
      notification.open({
        message: 'Successful transaction / Transacción exitosa ',
        duration: 2,
        placement: "bottomRight"
      });
      history.push(`${INTERNAL_LINKS.POLL_HOME}/${match.params.id}`);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const validQ9 = (value, index) => {
    let items = [ "a","b","c","d"];
    for(let item of items){
      const currentValue = form.getFieldValue(`q9_${item}`);
      if(currentValue === value && index !== item){
        form.setFieldsValue({ [`q9_${item}`]: null  });
      }
    }
  };

  const validQ10a = (value, index) => {
    let items = [ "a","b"];
    for(let item of items){
      const currentValue = form.getFieldValue(`q10_a_${item}`);
      if(currentValue === value && index !== item && currentValue !== 99){
        form.setFieldsValue({ [`q10_a_${item}`]: null  });
      }
    }
  };

  const validQ10b = (value, index) => {
    let items = [ "a","b", "c", "d", "e"];
    let countNull = 0;
    for(let item of items){
      const currentValue = form.getFieldValue(`q10_b_${item}`);
      if(currentValue != null){
        countNull++;
      }

      if(currentValue === value && index !== item){
        form.setFieldsValue({ [`q10_b_${item}`]: null  });
      }
    }
    if(countNull > 1){
      setQ10BRequired(false);
    } else {
      setQ10BRequired(true);
    }
  };

  const validQ10c = (value, index) => {
    let items = [ "a","b", "c", "d", "e", "f", "g", "h"];
    let countNull = 0;
    for(let item of items){
      const currentValue = form.getFieldValue(`q10_c_${item}`);
      if(currentValue != null){
        countNull++;
      }

      if(currentValue === value && index !== item){
        form.setFieldsValue({ [`q10_c_${item}`]: null  });
      }
    }
    if(countNull > 2){
      setQ10CRequired(false);
    } else {
      setQ10CRequired(true);
    }
  };

  const validQ10d = (value, index) => {
    let items = [ "a","b", "c", "d", "e", "f", "g", "h", "i", "j"];
    let countNull = 0;
    for(let item of items){
      const currentValue = form.getFieldValue(`q10_d_${item}`);
      if(currentValue != null){
        countNull++;
      }

      if(currentValue === value && index !== item){
        form.setFieldsValue({ [`q10_d_${item}`]: null  });
      }
    }
    if(countNull > 2){
      setQ10DRequired(false);
    } else {
      setQ10DRequired(true);
    }
  };

  const validQ11 = (value, index) => {
    let items = ["1","2","3","4","5","6","7","8","9","10","11"];
    let countNull = 0;
    for(let item of items){
      const currentValue = form.getFieldValue(`q11_${item}`);
      if(currentValue != null){
        countNull++;
      }
      
      if(currentValue === value && index !== item){
        form.setFieldsValue({ [`q11_${item}`]: null  });

        if (item === "11") {
          form.setFieldsValue({ [`q11_11_other`]: null  });
          setQ11_11Other(false);
        }
      }
    }
    if(countNull > 2){
      setQ11Required(false);
    } else {
      setQ11Required(true);
    }
  };

  const confirmClose = async (status) => {
    confirm({
      title: lang === 'en' ? 'Are you sure you want to CLOSE the chapter? If you do so, you will not be able to edit information later.' : '¿Está seguro de CERRAR el capítulo? Si lo hace no podrá editar información posteriormente.',
      icon: <ExclamationCircleOutlined />,
      onOk() {
        setStatusForm(status);
        if(status === 1) {
          setRequiredItems(false);
        } else if(status === 2) {
          setRequiredItems(true);
        }
        form.submit();
      },
      onCancel() {
        setStatusForm(0);
        setRequiredItems(false);
        form.submit();
      },
    });
  };

  return (<div>
    {
      lang === 'en' ?
        <Title level={3}>PART III: CHARACTERIZATION OF THE NEEDS OF MIGRANTS, REFUGEES AND THEIR HOST COMMUNITIES</Title> :
        <Title level={3}>PARTE III: CARACTERIZACIÓN DE NECESIDADES DE PERSONAS MIGRANTES, REFUGIADAS Y SUS COMUNIDADES DE ACOGIDA</Title>
    }
    <Form
      form={form}
      layout="vertical"
      onFinish={(data) => {
        save(data);
      }}
      validateMessages={FORM_MESSAGES[`validateMessages${lang.toUpperCase()}`]}
      scrollToFirstError={true}
    >
      <Form.Item
        label={`9. ${fileLang.q9.text}`}
        name="q9"
      >
        <span>{fileLang.q9.description}</span>
        <Table columns={[
          {
            title: fileLang.q9.headerColumn0,
            dataIndex: 'text',
            key: 'text',
          },
          {
            title: fileLang.q9.headerColumn1,
            dataIndex: 'value',
            key: 'value',
            render: (text, record) => {
              return (
                <Form.Item
                  name={`q9_${text}`}
                  rules={[{ required: requiredItems }]}
                >
                  <Select onChange={(value) => { validQ9(value, text); }}>
                    <Select.Option value={1}>1</Select.Option>
                    <Select.Option value={2}>2</Select.Option>
                    <Select.Option value={3}>3</Select.Option>
                    <Select.Option value={4}>4</Select.Option>
                  </Select>
                </Form.Item>);
            }
          },
        ]} dataSource={[
          { text: fileLang.q9.headerOptionA, value: "a" },
          { text: fileLang.q9.headerOptionB, value: "b" },
          { text: fileLang.q9.headerOptionC, value: "c" },
          { text: fileLang.q9.headerOptionD, value: "d" },
        ]}></Table>
      </Form.Item>
      <Form.Item
        label={`10. ${fileLang.q10.text}`}
        name="q10"
      >
        <span>{fileLang.q10.description}</span>
        <br></br>
        <br></br>
        <h4>{fileLang.q10.a.text}</h4>
        <Table columns={[
          {
            title: fileLang.q10.a.headerColumn0,
            dataIndex: 'text',
            key: 'text',
          },
          {
            title: fileLang.q10.a.headerColumn1,
            dataIndex: 'value',
            key: 'value',
            render: (text, record) => {
              return (
                <Form.Item
                  name={`q10_a_${text}`}
                  rules={[{ required: requiredItems }]}
                >
                  <Select onChange={(value) => { validQ10a(value, text); }}>
                    <Select.Option value={1}>1</Select.Option>
                    <Select.Option value={2}>2</Select.Option>
                    <Select.Option value={99}>NA</Select.Option>
                  </Select>
                </Form.Item>);
            }
          },
        ]} dataSource={[
          { text: fileLang.q10.a.headerOptionA, value: "a" },
          { text: fileLang.q10.a.headerOptionB, value: "b" },
        ]}></Table>
        <Form.Item
          label={`A. ${lang === "en" ? "Comments" : "Observaciones"}`}
          name="q10_a_comments"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <br></br>
        <br></br>
        <h4>{fileLang.q10.b.text}</h4>
        <span>{fileLang.q10.b.description}</span>
        <br></br>
        <br></br>
        <Table columns={[
          {
            title: fileLang.q10.b.headerColumn0,
            dataIndex: 'text',
            key: 'text',
          },
          {
            title: fileLang.q10.b.headerColumn1,
            dataIndex: 'value',
            key: 'value',
            render: (text, record) => {
              return (
                <Form.Item
                  name={`q10_b_${text}`}
                  rules={[{ required: requiredItems === true ? q10BRequired : requiredItems }]}
                >
                  <Select onChange={(value) => { validQ10b(value, text); }}>
                    <Select.Option value={1}>1</Select.Option>
                    <Select.Option value={2}>2</Select.Option>
                  </Select>
                </Form.Item>);
            }
          },
        ]} dataSource={[
          { text: fileLang.q10.b.headerOptionA, value: "a" },
          { text: fileLang.q10.b.headerOptionB, value: "b" },
          { text: fileLang.q10.b.headerOptionC, value: "c" },
          { text: fileLang.q10.b.headerOptionD, value: "d" },
          { text: fileLang.q10.b.headerOptionE, value: "e" },
        ]}></Table>
        <Form.Item
          label={`B. ${lang === "en" ? "Comments" : "Observaciones"}`}
          name="q10_b_comments"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <br></br>
        <br></br>
        <h4>{fileLang.q10.c.text}</h4>
        <span>{fileLang.q10.c.description}</span>
        <br></br>
        <br></br>
        <Table columns={[
          {
            title: fileLang.q10.c.headerColumn0,
            dataIndex: 'text',
            key: 'text',
          },
          {
            title: fileLang.q10.c.headerColumn1,
            dataIndex: 'value',
            key: 'value',
            render: (text, record) => {
              return (
                <Form.Item
                  name={`q10_c_${text}`}
                  rules={[{ required: requiredItems === true ? q10CRequired : requiredItems }]}
                >
                  <Select onChange={(value) => { validQ10c(value, text); }}>
                    <Select.Option value={1}>1</Select.Option>
                    <Select.Option value={2}>2</Select.Option>
                    <Select.Option value={3}>3</Select.Option>
                  </Select>
                </Form.Item>);
            }
          },
        ]} dataSource={[
          { text: fileLang.q10.c.headerOptionA, value: "a" },
          { text: fileLang.q10.c.headerOptionB, value: "b" },
          { text: fileLang.q10.c.headerOptionC, value: "c" },
          { text: fileLang.q10.c.headerOptionD, value: "d" },
          { text: fileLang.q10.c.headerOptionE, value: "e" },
          { text: fileLang.q10.c.headerOptionF, value: "f" },
          { text: fileLang.q10.c.headerOptionG, value: "g" },
          { text: fileLang.q10.c.headerOptionH, value: "h" },
        ]}></Table>
        <Form.Item
          label={`C. ${lang === "en" ? "Comments" : "Observaciones"}`}
          name="q10_c_comments"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <br></br>
        <br></br>
        <h4>{fileLang.q10.d.text}</h4>
        <span>{fileLang.q10.d.description}</span>
        <br></br>
        <br></br>
        <Table columns={[
          {
            title: fileLang.q10.d.headerColumn0,
            dataIndex: 'text',
            key: 'text',
          },
          {
            title: fileLang.q10.d.headerColumn1,
            dataIndex: 'value',
            key: 'value',
            render: (text, record) => {
              return (
                <Form.Item
                  name={`q10_d_${text}`}
                  rules={[{ required: requiredItems === true ? q10DRequired : requiredItems }]}
                >
                  <Select onChange={(value) => { validQ10d(value, text); }}>
                    <Select.Option value={1}>1</Select.Option>
                    <Select.Option value={2}>2</Select.Option>
                    <Select.Option value={3}>3</Select.Option>
                  </Select>
                </Form.Item>);
            }
          },
        ]} dataSource={[
          { text: fileLang.q10.d.headerOptionA, value: "a" },
          { text: fileLang.q10.d.headerOptionB, value: "b" },
          { text: fileLang.q10.d.headerOptionC, value: "c" },
          { text: fileLang.q10.d.headerOptionD, value: "d" },
          { text: fileLang.q10.d.headerOptionE, value: "e" },
          { text: fileLang.q10.d.headerOptionF, value: "f" },
          { text: fileLang.q10.d.headerOptionG, value: "g" },
          { text: fileLang.q10.d.headerOptionH, value: "h" },
          { text: fileLang.q10.d.headerOptionI, value: "i" },
          { text: fileLang.q10.d.headerOptionJ, value: "j" },
        ]}></Table>
      </Form.Item>
      <Form.Item
          label={`D. ${lang === "en" ? "Comments" : "Observaciones"}`}
          name="q10_d_comments"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
      <Form.Item
        label={`11. ${fileLang.q11.text}`}
        name="q11"
      >
        <Table pagination={{ pageSize: 15 }} columns={[
          {
            title: fileLang.q11.headerColumn0,
            dataIndex: 'text',
            key: 'text',
          },
          {
            title: fileLang.q11.headerColumn1,
            dataIndex: 'value',
            key: 'value',
            render: (text, record) => {
              return (
                <Form.Item
                  name={`q11_${text}`}
                  rules={[{ required: requiredItems === true ? q11Required : requiredItems }]}
                >
                  <Select onChange={(value) => { validQ11(value, text); handleQ11_11(value, text); }}>
                    <Select.Option value={1}>1</Select.Option>
                    <Select.Option value={2}>2</Select.Option>
                    <Select.Option value={3}>3</Select.Option>
                  </Select>
                </Form.Item>);
            }
          },
        ]} dataSource={[
          { text: fileLang.q11.headerOption1, value: "1" },
          { text: fileLang.q11.headerOption2, value: "2" },
          { text: fileLang.q11.headerOption3, value: "3" },
          { text: fileLang.q11.headerOption4, value: "4" },
          { text: fileLang.q11.headerOption5, value: "5" },
          { text: fileLang.q11.headerOption6, value: "6" },
          { text: fileLang.q11.headerOption7, value: "7" },
          { text: fileLang.q11.headerOption8, value: "8" },
          { text: fileLang.q11.headerOption9, value: "9" },
          { text: fileLang.q11.headerOption10, value: "10" },
          { text: fileLang.q11.headerOption11, value: "11" },
        ]}></Table>
      </Form.Item>
      {q11_11 === true &&
      <Form.Item
          label={`${fileLang.q11.questions.other}`}
          name="q11_11_other"
          rules={[{ required: requiredItems }]}
      >
        <Input.TextArea rows={4} />
      </Form.Item>
      }
      <Form.Item
        label={`12. ${fileLang.q12.text}`}
      >
        <Table columns={[
          {
            title: fileLang.q12.headerColumn0,
            dataIndex: 'text',
            key: 'text',
          },
          {
            title: fileLang.q12.headerColumn1,
            dataIndex: 'value',
            key: 'value',
            render: (text, record) => {
              return (
                <Form.Item
                  name={`q12_${text}`}
                  rules={[{ required: requiredItems }]}
                >
                  <Radio.Group>
                    <Radio value={0}>{Q12AnswersOptions[lang][0]}</Radio>
                    <Radio value={1}>{Q12AnswersOptions[lang][1]}</Radio>
                    <Radio value={2}>{Q12AnswersOptions[lang][2]}</Radio>
                    <Radio value={3}>{Q12AnswersOptions[lang][3]}</Radio>
                    <Radio value={4}>{Q12AnswersOptions[lang][4]}</Radio>
                    <Radio value={99}>{Q12AnswersOptions[lang][5]}</Radio>
                  </Radio.Group>
                </Form.Item>
              );
            }
          },
        ]} dataSource={[
          { value: "a", text: fileLang.q12.headerOptionA},
          { value: "b", text: fileLang.q12.headerOptionB},
          { value: "c", text: fileLang.q12.headerOptionC},
          { value: "d", text: fileLang.q12.headerOptionD},
          { value: "e", text: fileLang.q12.headerOptionE},
          { value: "f", text: fileLang.q12.headerOptionF},
          { value: "g", text: fileLang.q12.headerOptionG},
          { value: "h", text: fileLang.q12.headerOptionH},
          { value: "i", text: fileLang.q12.headerOptionI},
          { value: "j", text: fileLang.q12.headerOptionJ},
          { value: "k", text: fileLang.q12.headerOptionK},
          { value: "l", text: fileLang.q12.headerOptionL},
          { value: "m", text: fileLang.q12.headerOptionM},
          { value: "n", text: fileLang.q12.headerOptionN},
          { value: "o", text: fileLang.q12.headerOptionO}
        ]}></Table>
      </Form.Item>
      <Form.Item
        label={lang === "en" ? "Observations" : "Observaciones"}
        name="comments_iii"
      >
        <Input.TextArea rows={4} />
      </Form.Item>
      <Form.Item>
        <Space>
          {
            answer.status_iii < 2 &&
            <>
              <Button loading={loading} type="primary" onClick={() => { setStatusForm(0); setRequiredItems(false); }} htmlType="submit">{lang === 'en' ? 'Save (pending)' : 'Guardar (parcial)'}</Button>
              <Button loading={loading} type="primary" onClick={() => { confirmClose(1); }}>{lang === 'en' ? 'Close (unfinished)' : 'Cerrar (Parcial)'}</Button>
              <Button loading={loading} type="primary" onClick={() => { confirmClose(2); }}>{lang === 'en' ? 'Close' : 'Cerrar'}</Button>
            </>
          }
          <Button type="link"><Link to={`${INTERNAL_LINKS.POLL_HOME}/${match.params.id}`}>{lang === 'en' ? 'Back' : 'Volver'}</Link></Button>
        </Space>
      </Form.Item>
    </Form>
    <LoadingModal loading={loading} lang={lang}></LoadingModal>
  </div>);
};

export default PollChapterIII;